export enum AddressType {
  PERMANENT = 1,
  COMPANYASSIGNMENT = 2,
  OTHER = 3,
  TAXHOME = 4,
  COMPANYASSIGNMENTHOTEL = 5,
}
